import React from "react";
import Container from "../Container";
import "./index.scss";
import legalNotice from "../../assets/pdf/legal-notice.pdf";
import terms from "../../assets/pdf/terms-of-service.pdf";
import userGuide from "../../assets/pdf/user-guide.pdf";

export const Footer: React.FC = () => {
    return (
        <footer className="ec-footer">
            <Container >
                <ul className="ftList">
                    <li>
                        <a
                            href={'/pr_tableconro'}
                            target="_blank"
                        >
                            テーブルコンロのご購入は<br/>こちら
                        </a>
                    </li>
                    <li>
                        <a
                            href={'/pr_fh'}
                            target="_blank"
                        >
                            ファンヒーターのご購入は<br/>こちら
                        </a>
                    </li>
                    <li>
                        <a
                            href={terms}
                            target="_blank"
                        >
                            ご利用規約
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://www.saibugas.co.jp/policy/kojin_tori.htm"
                            target="_blank"
                        >
                            プライバシーポリシー
                        </a>
                    </li>
                    <li>
                        <a
                            href={userGuide}
                            target="_blank"
                        >
                            ご利用ガイド
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://hd.saibugas.co.jp/sitepolicy/"
                            target="_blank"
                        >
                            このWEBサイトについて
                        </a>
                    </li>
                    <li>
                        <a
                            href={legalNotice}
                            target="_blank"
                        >
                            特定商取引法に基づく表記
                        </a>
                    </li>
                </ul>
                <small>© SAIBUGAS Co.,Ltd.</small>
            </Container>
        </footer>
    );
};

export default Footer;
